export enum ContactTypes {
  PHONE = 51,
  EMAIL = 52,
  FAX = 53,
  MOBILE = 56,
  MOBILE_PHONE = 134,
  EXTENSION = 139,
}
